if (!customElements.get('ks-mega-menu')) {
  class KsMegaMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.ks-mega-menu__nav-btn');
      this.panels = this.querySelectorAll('.ks-mega-menu__panel');
      this.filterButtons = this.querySelectorAll('.ks-mega-menu__filter-btn');

      this.buttons.forEach((button) => {
        button.addEventListener('mouseenter', () => this.activate(button));
        button.addEventListener('focus', () => this.activate(button));
      });

      this.filterButtons.forEach((button) => {
        button.addEventListener('mouseenter', () => this.filter(button));
        button.addEventListener('focus', () => this.filter(button));
        button.addEventListener('click', () => this.filter(button));
      });

      this.pruneEmptyFilters();
      this.showAllProducts();
      this.addEventListener('mouseleave', () => this.showAllProducts());
    }

    pruneEmptyFilters() {
      if (!this.filterButtons.length) return;

      this.filterButtons.forEach((button) => {
        const filter = button.getAttribute('data-ks-mega-filter');
        if (!filter || filter === 'all') return;

        let count = 0;
        this.querySelectorAll('[data-ks-mega-categories]').forEach((item) => {
          const categories = (item.getAttribute('data-ks-mega-categories') || '').split(/\s+/);
          if (categories.includes(filter)) count += 1;
        });
        button.hidden = count === 0;
      });
    }

    activate(button) {
      const targetId = button.getAttribute('data-ks-mega-target');
      if (!targetId) return;

      this.buttons.forEach((btn) => btn.classList.toggle('is-active', btn === button));
      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === targetId);
      });
    }

    showAllProducts() {
      this.filterButtons.forEach((btn) => btn.classList.remove('is-active'));
      this.querySelectorAll('[data-ks-mega-categories]').forEach((item) => {
        const categories = (item.getAttribute('data-ks-mega-categories') || '').split(/\s+/);
        item.classList.toggle('is-hidden', !categories.includes('all'));
      });
    }

    filter(button) {
      const filter = button.getAttribute('data-ks-mega-filter');
      if (!filter) return;

      this.filterButtons.forEach((btn) => btn.classList.toggle('is-active', btn === button));
      this.querySelectorAll('[data-ks-mega-categories]').forEach((item) => {
        const categories = (item.getAttribute('data-ks-mega-categories') || '').split(/\s+/);
        item.classList.toggle('is-hidden', !categories.includes(filter));
      });
    }
  }

  customElements.define('ks-mega-menu', KsMegaMenu);
}
